import { useCallback, useReducer, useMemo } from 'react'
import R from 'ramda'

export const listReducer = (state, action) => {
  switch (action.type) {
    case 'NEW':
      return [...state, action.payload]
    case 'REMOVE_BY_INDEX':
      return R.remove(action.payload.index, 1, state)
    case 'UPDATE_BY_INDEX':
      return state.map((data, index) =>
        index === action.payload.index ? action.payload.data : data
      )
    case 'REMOVE':
      return R.filter(
        d => action.toIdent(d) !== action.toIdent(action.payload),
        state
      )
    case 'UPDATE':
      return state.map(data =>
        action.toIdent(data) === action.toIdent(action.payload)
          ? action.payload
          : data
      )
    case 'MOVE_BY_INDEX': {
      const end = R.compose(
        R.insert(
          action.payload.destinationIndex,
          state[action.payload.sourceIndex]
        ),
        R.remove(action.payload.sourceIndex, 1)
      )(state)

      return end
    }
    case 'REPLACE':
      return action.payload
  }
  return state
}

export const useListOperations = (initialState, opt = {}) => {
  const [state, dispatch] = useReducer(listReducer, initialState)
  const { toIdent = _ => _ } = opt

  const addNew = useCallback(payload => dispatch({ type: 'NEW', payload }), [
    dispatch,
  ])

  const removeByIndex = useCallback(
    index => {
      dispatch({ type: 'REMOVE_BY_INDEX', payload: { index } })
    },
    [dispatch]
  )
  const updateByIndex = useCallback(
    payload => {
      dispatch({ type: 'UPDATE_BY_INDEX', payload })
    },
    [dispatch]
  )

  const remove = useCallback(
    (payload, customToIdent) => {
      dispatch({ type: 'REMOVE', payload, toIdent: customToIdent || toIdent })
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [dispatch]
  )
  const update = useCallback(
    (payload, customToIdent) => {
      dispatch({ type: 'UPDATE', payload, toIdent: customToIdent || toIdent })
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [dispatch]
  )

  const moveByIndex = useCallback(
    payload => {
      dispatch({ type: 'MOVE_BY_INDEX', payload })
    },
    [dispatch]
  )

  const replace = useCallback(
    payload => {
      dispatch({ type: 'REPLACE', payload })
    },
    [dispatch]
  )

  const actions = useMemo(
    () => ({
      addNew,
      removeByIndex,
      updateByIndex,
      remove,
      update,
      moveByIndex,
      replace,
    }),
    [addNew, removeByIndex, updateByIndex, remove, update, moveByIndex, replace]
  )

  return [state, actions]
}
const noop = _ => _
export const noopActions = {
  addNew: noop,
  removeByIndex: noop,
  updateByIndex: noop,
  remove: noop,
  update: noop,
}
